import { useState } from "react";
import { KeyRound, ShieldCheck, ShieldOff, Smartphone } from "lucide-react";
import { Button } from "../ui/button";
import { NewCodesDialog } from "./NewCodesDialog";
import { MoveTwoStepDialog } from "./MoveTwoStepDialog";

// Account settings: the 2-step sign-in status, new recovery codes, and moving it to a new phone.
export const TwoStepCard = ({ enabled }) => {
  const [open, setOpen] = useState(null);
  return (
    <section data-testid="account-2fa-card" className="rounded-3xl border border-border bg-card p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-2xl ${enabled ? "bg-accent/15 text-accent" : "bg-muted text-muted-foreground"}`}>
          {enabled ? <ShieldCheck className="h-5 w-5" /> : <ShieldOff className="h-5 w-5" />}
        </span>
        <div className="min-w-0">
          <h2 className="font-heading text-lg font-bold">2-step sign-in</h2>
          <p data-testid="account-2fa-status" className="mt-1 text-sm text-muted-foreground">
            {enabled ? "On. Every sign-in asks for a code from your authenticator app." : "Off for this account."}
          </p>
        </div>
      </div>
      {enabled && (
        <div className="mt-6 flex flex-wrap gap-3">
          <Button data-testid="account-new-codes-btn" variant="outline" className="rounded-full gap-2" onClick={() => setOpen("codes")}>
            <KeyRound className="h-4 w-4" /> New recovery codes
          </Button>
          <Button data-testid="account-move-2fa-btn" variant="outline" className="rounded-full gap-2" onClick={() => setOpen("move")}>
            <Smartphone className="h-4 w-4" /> Move 2-step to a new phone
          </Button>
        </div>
      )}
      <NewCodesDialog open={open === "codes"} onOpenChange={(o) => setOpen(o ? "codes" : null)} />
      <MoveTwoStepDialog open={open === "move"} onOpenChange={(o) => setOpen(o ? "move" : null)} />
    </section>
  );
};
